import $ from 'jquery';

export const navigation = {	

	bootstrap: () => {
		
		navigation.initToggle();
		navigation.initSubMenus();
		navigation.initQuickMenu();

	},

	isTouch: () => ('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0),

	initToggle: () => {

		$(".navigation__toggle").on( 'click', () => {

			$("html").toggleClass("has-nav-toggled");

		} );

	},

	initSubMenus: () => {

		if ($("#main_menu .menu-item-has-children.current-menu-ancestor").length > 0) {
			$("#main_menu .menu-item-has-children.current-menu-ancestor").first().addClass("has-submenu-opened");
		}

		$("#main_menu .menu-item-has-children > a").on( 'click', function(e) {

			if ($(window).width() < 1280) {
				e.preventDefault();
			}

			if (!$(this).parent().hasClass("has-submenu-opened")) {
				$(this).parent().siblings().removeClass("has-submenu-opened");
				$(this).parent().addClass("has-submenu-opened");
			}
			else {
				$(this).parent().removeClass("has-submenu-opened");
			}


		});

	},

	initQuickMenu: () => {
		$(".home .quickmenu li").addClass("full-showed");

		$(window).scroll(function() {    
			var scroll = $(window).scrollTop();
			if (scroll <= 500) {
				$(".home .quickmenu li").addClass("full-showed");
			} else {
				$(".quickmenu li").removeClass("full-showed");
			}
		});

		$(".quickmenu li").hover(function() { 
			$(this).toggleClass("hovered");
		});

		$('.function-close').on( 'click', function() { 
			$(this).parent().removeClass("active");
			$('.quickmenu .menu-item').removeClass("active");
			$('.quickmenu .menu-item').removeClass("inactive");
			$('menu-quickicons').removeClass('active');
			$("html").removeClass("overflow-hidden");
		});

		$(".quickmenu a").on( 'click', function() {
			const type = $(this).attr("href").substring(1);
			const overlay = $("#quickmenu-overlays ." + type);
			$('.quickmenu li').removeClass('active');
			$("html").toggleClass("overflow-hidden");
			$(this).parent().addClass("active");

			if (overlay.hasClass("active")) {
				$(this).parent().siblings().removeClass("inactive");
				console.log($(this).parent().removeClass("active"))
				overlay.removeClass("active");
			}
			else {		
				$(this).parent().removeClass("inactive");		
				$(this).parent().siblings().addClass("inactive");
				overlay.siblings().removeClass("active");
				overlay.addClass("active");
			}
			
		});
	}

}

$(document).ready( navigation.bootstrap )